export const groupSegmentsByPnr = (segments = []) =>
  segments.reduce((acc, segment) => {
    const isSegmentIncluded = acc.length !== 0 && acc.some((x) => x.pnr === segment.pnr);

    if (!isSegmentIncluded) {
      return [...acc, segment];
    }

    const segmentPosition = acc.findIndex(
      (x) => x.pnr === segment.pnr && x.boundId === segment.boundId,
    );

    if (segmentPosition !== -1) {
      acc[segmentPosition] = {
        ...acc[segmentPosition],
        destination: segment.destination,
      };
    }

    return acc;
  }, []);
